<template>
    <Dialog
        :visible="visible"
        :header="obrigatorio ? 'Selecione a empresa' : 'Trocar de empresa'"
        modal
        :closable="!obrigatorio"
        :closeOnEscape="!obrigatorio"
        :draggable="false"
        :style="{ width: '26rem' }"
        :breakpoints="{ '640px': '92vw' }"
        @update:visible="$emit('update:visible', $event)"
        @show="focarSelecionado"
    >
        <fieldset class="tenant-fieldset">
            <legend class="tenant-legend">
                Os dados exibidos são apenas da empresa escolhida.
            </legend>

            <div v-for="tenant in tenants" :key="tenant.id" class="tenant-opcao">
                <RadioButton
                    v-model="escolhido"
                    :inputId="`tenant-opcao-${tenant.id}`"
                    :value="tenant.id"
                    name="tenant-ativo"
                    :disabled="salvando"
                />
                <label :for="`tenant-opcao-${tenant.id}`" class="tenant-label">
                    {{ tenant.nome }}
                    <span v-if="tenant.id === ativoId" class="tenant-atual">empresa ativa</span>
                </label>
            </div>
        </fieldset>

        <!-- Onde a preferência de entrada se define. Trocar de empresa é coisa
             da aba; só esta caixa decide em qual empresa o usuário entra da
             próxima vez que abrir o sistema. -->
        <div class="tenant-padrao">
            <Checkbox
                v-model="definirPadrao"
                inputId="tenant-padrao"
                binary
                :disabled="salvando || !escolhido"
            />
            <label for="tenant-padrao">Entrar sempre nesta empresa</label>
        </div>

        <template #footer>
            <Button
                v-if="!obrigatorio"
                label="Cancelar"
                severity="secondary"
                text
                :disabled="salvando"
                @click="$emit('update:visible', false)"
            />
            <Button
                label="Continuar"
                icon="pi pi-check"
                :loading="salvando"
                :disabled="!escolhido"
                @click="$emit('confirmar', { tenantId: escolhido, padrao: definirPadrao })"
            />
        </template>
    </Dialog>
</template>

<script>
import Dialog from 'primevue/dialog';
import RadioButton from 'primevue/radiobutton';
import Button from 'primevue/button';
import Checkbox from 'primevue/checkbox';

/**
 * Só apresentação: escolhe um tenant entre os autorizados e devolve o id.
 * Quem persiste e decide o que fazer com a escolha é o TenantSwitcher.
 */
export default {
    name: 'TenantSelectDialog',
    components: { Dialog, RadioButton, Button, Checkbox },
    props: {
        visible: { type: Boolean, default: false },
        tenants: { type: Array, default: () => [] },
        ativoId: { type: Number, default: null },
        /** Preferência de entrada já salva, ou `null` se nunca foi definida. */
        padraoId: { type: Number, default: null },
        /** Seleção de entrada (T4.2): não dá para fechar sem escolher. */
        obrigatorio: { type: Boolean, default: false },
        salvando: { type: Boolean, default: false },
    },
    emits: ['update:visible', 'confirmar'],
    data() {
        // Nunca vê valor no mount: o pai carrega os tenants por request, e
        // `ativoId` chega depois. Quem preenche são os watchers.
        return { escolhido: null, definirPadrao: false };
    },
    watch: {
        visible(aberto) {
            if (aberto) this.escolhido = this.ativoId;
        },
        ativoId(valor) {
            this.escolhido = valor;
        },
        // A caixa reflete o estado salvo da empresa que está selecionada no
        // momento, não a do request: marcar, mudar de opção e confirmar
        // definiria como padrão uma empresa que o usuário nem olhou.
        escolhido(valor) {
            this.definirPadrao = valor !== null && valor === this.padraoId;
        },
    },
    methods: {
        // O foco entra na opção já ativa, não na primeira da lista: é o que o
        // leitor de tela anuncia e o ponto de partida das setas do teclado.
        focarSelecionado() {
            document.getElementById(`tenant-opcao-${this.escolhido}`)?.focus();
        },
    },
};
</script>

<style scoped>
.tenant-fieldset { border: 0; padding: 0; margin: 0; }
.tenant-legend { padding: 0; margin-bottom: 1rem; font-size: 0.875rem; opacity: 0.75; }
.tenant-opcao { display: flex; align-items: center; gap: 0.75rem; padding: 0.25rem 0; }
.tenant-label { cursor: pointer; flex: 1; padding: 0.5rem 0; }
.tenant-atual { margin-left: 0.5rem; font-size: 0.75rem; opacity: 0.6; }
.tenant-padrao {
    display: flex;
    align-items: center;
    gap: 0.75rem;
    margin-top: 1rem;
    padding-top: 1rem;
    border-top: 1px solid var(--surface-border, rgba(255, 255, 255, 0.1));
    font-size: 0.875rem;
}
.tenant-padrao label { cursor: pointer; }
</style>
